import { useState } from 'react';
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import RubricPDF from './RubricPDF';

const RubricDisplay = ({ rubricData }) => {
    const [showPDF, setShowPDF] = useState(false);
    
    if (!rubricData?.rubrics?.length) return null;
    console.log("rubricData", rubricData);

    return (
        <div className="space-y-8">
            <div className="flex justify-end gap-4 mb-4">
                <button
                    onClick={() => setShowPDF(!showPDF)}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                    {showPDF ? 'Show Table View' : 'Show PDF Preview'}
                </button>
                <PDFDownloadLink
                    document={<RubricPDF rubricData={rubricData} />}
                    fileName="rubric.pdf"
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                >
                    {({ loading }) => (loading ? 'Loading...' : 'Download PDF')}
                </PDFDownloadLink>
            </div>

            {showPDF ? (
                <PDFViewer className="w-full h-[600px]">
                    <RubricPDF rubricData={rubricData} />
                </PDFViewer>
            ) : (
                <div className="border rounded-lg overflow-hidden">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 w-1/4">Criterion</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 w-1/5">Below Expectations<br/>(0-2)</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 w-1/5">Meets Expectations<br/>(2-4)</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 w-1/5">Exceeds Expectations<br/>(4-5)</th>
                                <th className="px-4 py-3 text-center text-sm font-medium text-gray-900 w-1/12">Score</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {rubricData.rubrics.map((rubric, index) => (
                                <tr key={index}>
                                    <td className="px-4 py-4">
                                        <div className="font-medium text-gray-900">{rubric.competency}</div>
                                        
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-600">
                                        {rubric.criteria.below_expectations.description}
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-600">
                                        {rubric.criteria.meets_expectations.description}
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-600">
                                        {rubric.criteria.exceeds_expectations.description}
                                    </td>
                                    <td className="px-4 py-4 text-center">
                                        <div className="w-12 h-8 border rounded mx-auto"></div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default RubricDisplay; 